/**
 * <AccountChoicePage> — « Ajouter un compte » (page), l'arrivée du « + » de « Qui utilise Masteur ? ».
 *
 * Les gestes de l'ancien écran « Choisir une option », un par un : se connecter à un compte qui
 * existe, inscrire un élève (le formulaire du site), devenir tuteur. Deux questions, chacune avec sa
 * réponse, séparées par « ou » : on ajoute un compte qu'on a déjà, ou on en crée un.
 *
 * Contrôlée : elle ne sait rien de la navigation, les gestes remontent par callbacks.
 */
import React from "react"

import { Button } from "../../atoms/Buttons/Button"
import { TextButton } from "../../atoms/Buttons/TextButton"
import { Stack } from "../../atoms/containers/Stack"
import { Divider } from "../../atoms/Divider"
import { Text } from "../../atoms/typography/Text"
import { AuthHeading } from "../../molecules/AuthHeading"
import { AuthTemplate } from "../../templates/AuthTemplate"

const TITLE = "Ajouter un compte"
const HAS_ACCOUNT = "Vous avez déjà un compte ?"
const SIGN_IN_LABEL = "Me connecter"
const NEW_HERE = "Nouveau sur Masteur ?"
const ADD_STUDENT_LABEL = "Ajouter un élève"
const BECOME_TUTOR_LABEL = "Devenir tuteur"

export type AccountChoicePageProps = {
    /** « Me connecter » : la connexion, pour un compte qui existe déjà. */
    onSignIn: () => void
    /** « Ajouter un élève » : le formulaire d'inscription du site. */
    onAddStudent: () => void
    /** « Devenir tuteur » : la candidature tuteur. */
    onBecomeTutor: () => void
    onBack?: () => void
    testID?: string
}

export function AccountChoicePage(props: AccountChoicePageProps) {
    const { onSignIn, onAddStudent, onBecomeTutor, onBack } = props

    return (
        <AuthTemplate onBack={onBack} testID={props.testID}>
            <Stack gap="8">
                <AuthHeading title={TITLE} />

                <Stack gap="3">
                    <Text center weight="bold">
                        {HAS_ACCOUNT}
                    </Text>
                    <Button label={SIGN_IN_LABEL} fullWidth onPress={onSignIn} />
                </Stack>

                <Divider label="ou" />

                <Stack gap="3">
                    <Text center weight="bold">
                        {NEW_HERE}
                    </Text>
                    <Button
                        variant="outline"
                        iconName="plus"
                        label={ADD_STUDENT_LABEL}
                        fullWidth
                        onPress={onAddStudent}
                    />
                    <Stack align="center">
                        <TextButton label={BECOME_TUTOR_LABEL} onPress={onBecomeTutor} />
                    </Stack>
                </Stack>
            </Stack>
        </AuthTemplate>
    )
}
